import React, { useEffect, useState, useRef } from 'react';
import api from './api/client';

const MOBILE_APP_URL = '/downloads/qserve-mobile-1.0.1.apk';
const CONTACT_EMAIL = 'maisqserve@gmail.com';
const WHATSAPP_NUMBER = '5521971848125';
const WHATSAPP_DISPLAY = '(21) 97184-8125';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent('Ola, preciso de atendimento pelo +Qserve.')}`;

const safePublicUrl = (value) => {
  try {
    const parsed = new URL(String(value || ''), window.location.origin);
    return parsed.protocol === 'https:' ? parsed.toString() : null;
  } catch (_) {
    return null;
  }
};

// ── Design tokens ──────────────────────────────────────────
const C = {
  bg: '#0d0f1a', surface: '#111320', card: '#161B26',
  border: '#1E2535',
  accent: '#00D4A0', accentDim: '#00D4A015', accentHov: '#00EDBA',
  gold: '#F0A500', goldDim: '#F0A50015',
  danger: '#FF4560', info: '#3D8EFF',
  text: '#E8EDF8', sub: '#7A8699', muted: '#404B60',
  font: "'DM Sans', sans-serif",
};

// ── Inject CSS ─────────────────────────────────────────────
const injectLandingStyles = () => {
  if (document.getElementById('landing-styles')) return;
  const s = document.createElement('style');
  s.id = 'landing-styles';
  s.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800;900&display=swap');
    html, body, #root { width: 100%; max-width: 100%; overflow-x: hidden; }
    body { font-family: ${C.font}; background: ${C.bg}; color: ${C.text}; overflow-x: hidden; }
    .l-page { width: 100%; max-width: 100%; overflow-x: hidden; }
    .l-page, .l-page * { box-sizing: border-box; min-width: 0; }
    .l-page img, .l-page video, .l-page canvas, .l-page svg { max-width: 100%; }
    .l-page button, .l-page a, .l-page input, .l-page textarea { max-width: 100%; }

    @keyframes lFadeUp { from { opacity:0; transform:translateY(24px); } to { opacity:1; transform:translateY(0); } }
    @keyframes lBlink  { 0%,100%{ opacity:1; } 50%{ opacity:0.3; } }
    @keyframes lFloat  { 0%,100%{ transform:translateY(0); } 50%{ transform:translateY(-8px); } }

    .l-fade   { animation: lFadeUp 0.65s ease both; }
    .l-fade2  { animation: lFadeUp 0.65s ease 0.12s both; }
    .l-fade3  { animation: lFadeUp 0.65s ease 0.24s both; }
    .l-fade4  { animation: lFadeUp 0.65s ease 0.36s both; }

    .l-cta { transition: transform 0.18s, box-shadow 0.18s; }
    .l-cta:hover { transform: translateY(-3px) !important; box-shadow: 0 16px 40px ${C.accent}45 !important; }
    .l-ghost:hover { background: ${C.accentDim} !important; color: ${C.accent} !important; border-color: ${C.accent} !important; }

    .l-card { transition: transform 0.22s, border-color 0.22s, box-shadow 0.22s; }
    .l-card:hover { transform: translateY(-5px); border-color: ${C.accent}55 !important; box-shadow: 0 16px 40px #00000055 !important; }

    .l-step { transition: border-color 0.22s, box-shadow 0.22s; }
    .l-step:hover { border-color: ${C.accent}60 !important; box-shadow: 0 8px 32px ${C.accent}12 !important; }

    .l-nav-link { transition: color 0.15s, background 0.15s; }
    .l-nav-link:hover { color: ${C.accent} !important; }

    .l-ham-btn { display: none; }

    /* Responsive */
    @media (max-width: 900px) {
      .l-hero-grid  { flex-direction: column !important; }
      .l-hero-img   { width: 100% !important; height: 260px !important; }
      .l-steps-grid { grid-template-columns: 1fr !important; }
      .l-feat-grid  { grid-template-columns: repeat(2,1fr) !important; }
      .l-svc-grid   { grid-template-columns: repeat(3,1fr) !important; }
      .l-test-grid  { grid-template-columns: 1fr !important; }
      .l-nav-links  { display: none !important; }
      .l-ham-btn    { display: flex !important; }
      .l-stats-grid { grid-template-columns: repeat(2,1fr) !important; }
      .l-who-grid   { grid-template-columns: repeat(2,1fr) !important; }
      .l-footer-top { flex-direction: column !important; }
    }
    @media (max-width: 540px) {
      .l-page { width: 100vw !important; max-width: 100vw !important; }
      .l-page section { padding-left: 18px !important; padding-right: 18px !important; }
      .l-page section > div, .l-hero-grid, .l-hero-grid > div { width: 100% !important; max-width: 100% !important; }
      .l-nav { height: 60px !important; padding-left: 16px !important; padding-right: 16px !important; }
      .l-brand-domain { display: none !important; }
      .l-mobile-menu { top: 60px !important; padding: 10px 16px 14px !important; }
      .l-hero-section { min-height: auto !important; padding-left: 0 !important; padding-right: 0 !important; }
      .l-hero-img { height: auto !important; }
      .l-hero-grid { padding: 48px 18px 42px !important; gap: 24px !important; }
      .l-hero-title, .l-hero-copy, .l-hero-actions { max-width: calc(100vw - 36px) !important; }
      .l-hero-title  {
        font-size: clamp(28px, 8vw, 34px) !important;
        line-height: 1.08 !important;
        letter-spacing: 0 !important;
        overflow-wrap: anywhere !important;
      }
      .l-hero-copy { font-size: 15px !important; line-height: 1.62 !important; max-width: 100% !important; margin-bottom: 26px !important; }
      .l-hero-actions { align-items: stretch !important; flex-direction: column !important; width: 100% !important; gap: 10px !important; }
      .l-hero-actions > button, .l-cta-wide { width: 100% !important; max-width: calc(100vw - 36px) !important; justify-content: center !important; text-align: center !important; }
      .l-page button, .l-page a { white-space: normal !important; }
      .l-stats-grid { grid-template-columns: repeat(2,minmax(0,1fr)) !important; gap: 12px !important; margin-top: 32px !important; padding-top: 24px !important; }
      .l-section-head { margin-bottom: 28px !important; }
      .l-section-title { font-size: clamp(24px, 8vw, 30px) !important; line-height: 1.16 !important; letter-spacing: 0 !important; overflow-wrap: anywhere !important; }
      .l-section-sub { font-size: 14px !important; line-height: 1.62 !important; max-width: 100% !important; }
      .l-svc-grid    { grid-template-columns: repeat(2,minmax(0,1fr)) !important; gap: 10px !important; }
      .l-feat-grid   { grid-template-columns: 1fr !important; }
      .l-contact-row { flex-direction: column !important; }
      .l-contact-row > div { width: 100% !important; flex-basis: 100% !important; }
      .l-who-grid { grid-template-columns: 1fr !important; width: 100% !important; }
      .l-step-arrow { display: none !important; }
      .l-promo-grid { grid-template-columns: 1fr !important; }
      .l-download-panel { max-width: 100% !important; width: 100% !important; }
      .l-footer-top > div { width: 100% !important; min-width: 0 !important; }
      .l-footer-bottom { align-items: flex-start !important; flex-direction: column !important; }
    }
  `;
  document.head.appendChild(s);
};

// ── Static data ────────────────────────────────────────────
const SERVICES = [
  { icon: '🧹', label: 'Limpeza',      color: C.accent },
  { icon: '⚡', label: 'Elétrica',     color: C.gold   },
  { icon: '🔧', label: 'Encanamento',  color: '#3D8EFF' },
  { icon: '🌿', label: 'Jardinagem',   color: C.accent },
  { icon: '🎨', label: 'Pintura',      color: '#9B6DFF' },
  { icon: '🏗️', label: 'Reformas',    color: C.danger  },
  { icon: '🎵', label: 'Eventos',      color: C.gold   },
];

const STEPS = [
  { n: '01', icon: '📱', title: 'Solicite o serviço pelo app ou site', desc: 'Escolha a categoria, informe o endereço e data. Pronto em menos de 2 minutos.' },
  { n: '02', icon: '👷', title: 'Profissional verificado aceita e vai até você', desc: 'Colaboradores aprovados com documentação verificada aceitam sua vaga.' },
  { n: '03', icon: '💸', title: 'Confirme o serviço e pague com segurança via PIX', desc: 'Ao final, você fornece o token exclusivo e o pagamento é liberado.' },
];

const WHO_BADGES = [
  { icon: '✅', label: 'Verificados' },
  { icon: '🏅', label: 'Certificados' },
  { icon: '🔒', label: 'Seguros' },
  { icon: '⭐', label: 'Confiáveis' },
];

const TESTIMONIALS = [
  { name: 'Mariana S.', role: 'Cliente', initials: 'MS', rating: 5, text: 'Contratei um eletricista pelo +Qserve e fui atendida no mesmo dia. Profissional pontual, preço justo e serviço impecável. Super recomendo!' },
  { name: 'João P.', role: 'Cliente', initials: 'JP', rating: 5, text: 'Sistema de token para confirmar o serviço é genial! Só paguei quando fiquei satisfeito com o resultado. Senti total segurança do começo ao fim.' },
  { name: 'Ana C.', role: 'Cliente', initials: 'AC', rating: 5, text: 'Serviço de jardinagem excelente! O profissional chegou no horário, usou os materiais corretos e deixou tudo impecável. Voltarei a usar com certeza.' },
];

const STATS = [
  { value: '500+', label: 'Serviços Realizados' },
  { value: '200+', label: 'Colaboradores Ativos' },
  { value: '98%',  label: 'Satisfação' },
  { value: 'Brasil', label: 'Cobertura nacional' },
];

// ── Components ─────────────────────────────────────────────
const Tag = ({ children, color = C.accent }) => (
  <span style={{
    display: 'inline-block',
    background: color + '15', color, border: `1px solid ${color}40`,
    borderRadius: 20, padding: '4px 14px',
    fontSize: 11, fontWeight: 700, letterSpacing: 1.5, textTransform: 'uppercase',
  }}>{children}</span>
);

const SectionTitle = ({ tag, title, sub, center = true }) => (
  <div className="l-section-head" style={{ textAlign: center ? 'center' : 'left', marginBottom: 44 }}>
    {tag && <div style={{ marginBottom: 12 }}><Tag>{tag}</Tag></div>}
    <h2 className="l-section-title" style={{ fontSize: 34, fontWeight: 900, color: C.text, letterSpacing: -0.5, marginBottom: sub ? 10 : 0 }}>{title}</h2>
    {sub && <p className="l-section-sub" style={{ color: C.sub, fontSize: 16, lineHeight: 1.7, maxWidth: 580, margin: center ? '0 auto' : '0' }}>{sub}</p>}
  </div>
);

// ── Main component ─────────────────────────────────────────
export default function LandingPage({ onEnter }) {
  const [promotions, setPromotions] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [contactForm, setContactForm] = useState({ name: '', email: '', message: '' });
  const [contactSent, setContactSent] = useState(false);
  const [contactLoading, setContactLoading] = useState(false);
  const [contactError, setContactError] = useState('');
  const menuRef = useRef(null);

  useEffect(() => {
    injectLandingStyles();
    api.promotions.list()
      .then((d) => setPromotions(d.promotions || []))
      .catch(() => {});
  }, []);

  useEffect(() => {
    const close = (e) => { if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  const goRegister = () => onEnter('register');
  const goLogin    = () => onEnter('login');

  const setContact = (k) => (e) => setContactForm((f) => ({ ...f, [k]: e.target.value }));
  const sendContact = async (e) => {
    e.preventDefault();
    setContactLoading(true);
    setContactError('');
    try {
      await api.contact.send(contactForm);
      setContactSent(true);
    } catch (err) {
      setContactError(err.message || 'Nao foi possivel enviar sua mensagem agora.');
    } finally {
      setContactLoading(false);
    }
  };

  const navLinks = [
    { href: '#quem-somos',    label: 'Quem Somos' },
    { href: '#servicos',      label: 'Serviços' },
    { href: '#como-funciona', label: 'Como Funciona' },
    { href: '#depoimentos',   label: 'Depoimentos' },
    { href: '#download',      label: 'Baixar App' },
    { href: '#contato',       label: 'Contato' },
  ];

  return (
    <div className="l-page" style={{ background: C.bg, fontFamily: C.font, overflowX: 'hidden' }}>

      {/* ═══ NAVBAR ═══════════════════════════════════════ */}
      <nav ref={menuRef} className="l-nav" style={{
        position: 'sticky', top: 0, zIndex: 200,
        background: C.bg + 'f4', backdropFilter: 'blur(16px)',
        borderBottom: `1px solid ${C.border}`,
        padding: '0 5%', height: 64,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <div style={{
            width: 36, height: 36, borderRadius: 10,
            background: `linear-gradient(135deg, ${C.accent}, #00a880)`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 18, fontWeight: 900, color: '#000',
            boxShadow: `0 4px 14px ${C.accent}40`,
          }}>Q</div>
          <div>
            <div style={{ fontWeight: 900, fontSize: 18, color: C.text, lineHeight: 1 }}>+Qserve</div>
            <div className="l-brand-domain" style={{ fontSize: 9, color: C.sub, letterSpacing: 1, textTransform: 'uppercase' }}>maisqserve.com.br</div>
          </div>
        </div>

        {/* Desktop nav */}
        <div className="l-nav-links" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          {navLinks.map((l) => (
            <a key={l.href} href={l.href} className="l-nav-link" style={{
              color: C.sub, fontSize: 14, fontWeight: 600, textDecoration: 'none',
              padding: '7px 13px', borderRadius: 8,
            }}>{l.label}</a>
          ))}
          <div style={{ width: 1, height: 24, background: C.border, margin: '0 8px' }} />
          <button onClick={goLogin} className="l-ghost" style={{
            background: 'none', border: `1px solid ${C.border}`, color: C.text,
            borderRadius: 9, padding: '8px 18px', fontWeight: 700, fontSize: 14,
            cursor: 'pointer', fontFamily: C.font, transition: 'all 0.15s',
          }}>Entrar</button>
          <button onClick={goRegister} className="l-cta" style={{
            background: C.accent, color: '#000', border: 'none',
            borderRadius: 9, padding: '8px 20px', fontWeight: 800, fontSize: 14,
            cursor: 'pointer', fontFamily: C.font, marginLeft: 4,
          }}>Cadastrar →</button>
        </div>

        {/* Hamburger */}
        <button className="l-ham-btn" onClick={() => setMenuOpen(!menuOpen)} style={{
          background: 'none', border: `1px solid ${C.border}`, color: C.text,
          borderRadius: 8, padding: '8px 12px', cursor: 'pointer', fontFamily: C.font, fontSize: 18,
          alignItems: 'center', justifyContent: 'center',
        }}>☰</button>

        {/* Mobile dropdown */}
        {menuOpen && (
          <div className="l-mobile-menu" style={{
            position: 'absolute', top: 64, left: 0, right: 0,
            background: C.surface, borderBottom: `1px solid ${C.border}`,
            padding: '12px 5%', zIndex: 300,
            display: 'flex', flexDirection: 'column', gap: 4,
          }}>
            {navLinks.map((l) => (
              <a key={l.href} href={l.href} onClick={() => setMenuOpen(false)} style={{
                color: C.sub, fontSize: 15, fontWeight: 600, textDecoration: 'none',
                padding: '10px 12px', borderRadius: 8, display: 'block',
              }}>{l.label}</a>
            ))}
            <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
              <button onClick={() => { setMenuOpen(false); goLogin(); }} style={{ flex: 1, background: C.surface, border: `1px solid ${C.border}`, color: C.text, borderRadius: 8, padding: '10px 0', fontWeight: 700, cursor: 'pointer', fontFamily: C.font }}>Entrar</button>
              <button onClick={() => { setMenuOpen(false); goRegister(); }} style={{ flex: 1, background: C.accent, border: 'none', color: '#000', borderRadius: 8, padding: '10px 0', fontWeight: 800, cursor: 'pointer', fontFamily: C.font }}>Cadastrar</button>
            </div>
          </div>
        )}
      </nav>

      {/* ═══ HERO ═════════════════════════════════════════ */}
      <section className="l-hero-section" style={{
        position: 'relative', overflow: 'hidden',
        minHeight: 560,
      }}>
        {/* Background image / placeholder */}
        <div
          className="l-hero-img"
          style={{
            position: 'absolute', inset: 0,
            backgroundImage: `url('/images/hero.jpg'), linear-gradient(135deg, #0d1a14 0%, #0d0f1a 100%)`,
            backgroundSize: 'cover', backgroundPosition: 'center',
            filter: 'brightness(0.35)',
          }}
        >
          {/* Placeholder shown when image not found — pure CSS overlay */}
          <div style={{
            position: 'absolute', inset: 0,
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            gap: 12, pointerEvents: 'none',
          }}>
            <div style={{ fontSize: 48, opacity: 0.18 }}>📷</div>
            <div style={{ fontSize: 12, color: '#fff', opacity: 0.18, letterSpacing: 1, textAlign: 'center', padding: '0 20px' }}>
              Adicione sua foto em frontend/public/images/hero.jpg
            </div>
          </div>
        </div>

        {/* Gradient overlay */}
        <div style={{
          position: 'absolute', inset: 0,
          background: `linear-gradient(90deg, ${C.bg}e0 40%, ${C.bg}60 100%)`,
        }} />

        <div className="l-hero-grid" style={{
          position: 'relative', zIndex: 1,
          display: 'flex', alignItems: 'center', gap: 48,
          maxWidth: 1100, margin: '0 auto',
          padding: '80px 5%',
        }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div className="l-fade" style={{ marginBottom: 22 }}>
              <Tag>Serviços para todo o Brasil</Tag>
            </div>

            <h1 className="l-hero-title l-fade2" style={{
              fontSize: 52, fontWeight: 900, color: C.text,
              lineHeight: 1.1, letterSpacing: -1.5, marginBottom: 20,
            }}>
              Serviço de qualidade,{' '}
              <span style={{ color: C.accent }}>na hora certa!</span>
            </h1>

            <p className="l-hero-copy l-fade3" style={{
              fontSize: 17, color: C.sub, maxWidth: 480,
              lineHeight: 1.75, marginBottom: 36,
            }}>
              Conectamos clientes a colaboradores <strong style={{ color: C.text }}>verificados e certificados</strong> para serviços domésticos, técnicos e eventos em todo o Brasil.
            </p>

            <div className="l-hero-actions l-fade4" style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
              <button className="l-cta l-cta-wide" onClick={goRegister} style={{
                background: C.accent, color: '#000', border: 'none',
                borderRadius: 13, padding: '15px 34px',
                fontWeight: 900, fontSize: 16, cursor: 'pointer', fontFamily: C.font,
                boxShadow: `0 8px 28px ${C.accent}40`,
              }}>Solicitar um serviço agora →</button>
              <button className="l-ghost l-cta-wide" onClick={goLogin} style={{
                background: 'transparent', color: C.text,
                border: `1px solid rgba(255,255,255,0.25)`,
                borderRadius: 13, padding: '15px 28px',
                fontWeight: 700, fontSize: 16, cursor: 'pointer', fontFamily: C.font,
                transition: 'all 0.2s',
              }}>Sou colaborador</button>
            </div>

            <div className="l-fade4" style={{
              display: 'flex', gap: 10, flexWrap: 'wrap',
              marginTop: 18, maxWidth: 520,
            }}>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" style={{
                display: 'inline-flex', alignItems: 'center', gap: 8,
                border: '1px solid #25D36670', background: '#25D36618',
                color: '#9FF2BE', textDecoration: 'none',
                borderRadius: 10, padding: '10px 14px',
                fontWeight: 800, fontSize: 13,
              }}>
                WhatsApp {WHATSAPP_DISPLAY}
              </a>
              <a href={`mailto:${CONTACT_EMAIL}`} style={{
                display: 'inline-flex', alignItems: 'center', gap: 8,
                border: `1px solid ${C.border}`, background: C.surface,
                color: C.text, textDecoration: 'none',
                borderRadius: 10, padding: '10px 14px',
                fontWeight: 700, fontSize: 13,
              }}>
                {CONTACT_EMAIL}
              </a>
            </div>

            {/* Stats */}
            <div className="l-stats-grid l-fade4" style={{
              display: 'grid', gridTemplateColumns: 'repeat(4,1fr)',
              gap: 20, marginTop: 48, paddingTop: 32,
              borderTop: '1px solid rgba(255,255,255,0.08)',
            }}>
              {STATS.map((s) => (
                <div key={s.label}>
                  <div style={{ fontSize: 26, fontWeight: 900, color: C.accent, letterSpacing: -0.5 }}>{s.value}</div>
                  <div style={{ fontSize: 12, color: C.sub, marginTop: 2 }}>{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ═══ QUEM SOMOS ═══════════════════════════════════ */}
      <section id="quem-somos" style={{ padding: '72px 5%', background: C.surface + '70' }}>
        <div style={{ maxWidth: 1000, margin: '0 auto' }}>
          <SectionTitle
            tag="Quem Somos"
            title="Mão de obra verificada e certificada"
            center={false}
          />
          <div style={{ display: 'flex', gap: 48, alignItems: 'flex-start', flexWrap: 'wrap' }}>
            <div style={{ flex: '1 1 360px', minWidth: 0 }}>
              <p style={{ color: C.sub, fontSize: 16, lineHeight: 1.85, marginBottom: 24 }}>
                <strong style={{ color: C.text }}>+Qserve</strong> é uma plataforma fornecedora de mão de obra verificada e certificada. Conectamos você aos melhores profissionais da sua região, com segurança, transparência e qualidade garantida.
              </p>
              <p style={{ color: C.sub, fontSize: 16, lineHeight: 1.85 }}>
                Todos os nossos colaboradores passam por rigoroso processo de verificação documental, biometria e consulta de antecedentes antes de serem aprovados — para que você receba um serviço com total tranquilidade.
              </p>
            </div>
            <div className="l-who-grid" style={{ flex: '1 1 260px', display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 14 }}>
              {WHO_BADGES.map((b) => (
                <div key={b.label} className="l-card" style={{
                  background: C.card, border: `1px solid ${C.border}`,
                  borderRadius: 14, padding: '20px 18px',
                  display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10,
                  textAlign: 'center',
                }}>
                  <div style={{
                    width: 48, height: 48, borderRadius: 12,
                    background: C.accentDim, border: `1px solid ${C.accent}30`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22,
                  }}>{b.icon}</div>
                  <span style={{ fontWeight: 800, fontSize: 14, color: C.text }}>{b.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ═══ COMO FUNCIONA ════════════════════════════════ */}
      <section id="como-funciona" style={{ padding: '72px 5%' }}>
        <div style={{ maxWidth: 1000, margin: '0 auto' }}>
          <SectionTitle
            tag="Como Funciona"
            title="Simples, rápido e seguro"
            sub="Em 3 passos você já tem um profissional trabalhando para você"
          />
          <div className="l-steps-grid" style={{
            display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 20,
          }}>
            {STEPS.map((step, i) => (
              <div key={step.n} className="l-step" style={{
                background: C.surface, border: `1px solid ${C.border}`,
                borderRadius: 18, padding: 28, position: 'relative',
              }}>
                <div style={{
                  fontSize: 54, fontWeight: 900, color: C.accent + '16',
                  position: 'absolute', top: 14, right: 18, lineHeight: 1,
                }}>{step.n}</div>
                {i < STEPS.length - 1 && (
                  <div className="l-step-arrow" style={{
                    position: 'absolute', top: '44px', right: '-14px',
                    color: C.accent, fontSize: 22, fontWeight: 900, zIndex: 1,
                  }}>›</div>
                )}
                <div style={{
                  width: 54, height: 54, borderRadius: 14,
                  background: `linear-gradient(135deg, ${C.accentDim}, ${C.accent}20)`,
                  border: `1px solid ${C.accent}30`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 24, marginBottom: 18,
                }}>{step.icon}</div>
                <div style={{ fontWeight: 800, fontSize: 16, color: C.text, marginBottom: 10, lineHeight: 1.3 }}>{step.title}</div>
                <div style={{ color: C.sub, fontSize: 14, lineHeight: 1.7 }}>{step.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══ SERVIÇOS ═════════════════════════════════════ */}
      <section id="servicos" style={{ padding: '72px 5%', background: C.surface + '50' }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          <SectionTitle
            tag="Serviços"
            title="O que você precisa?"
            sub="Profissionais especializados para cada tipo de serviço"
          />
          <div className="l-svc-grid" style={{
            display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 14,
          }}>
            {SERVICES.map((svc) => (
              <button
                key={svc.label} onClick={goRegister}
                className="l-card"
                style={{
                  background: C.card, border: `1px solid ${C.border}`,
                  borderRadius: 16, padding: '22px 14px',
                  textAlign: 'center', cursor: 'pointer',
                  display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10,
                  fontFamily: C.font,
                }}
              >
                <div style={{
                  width: 52, height: 52, borderRadius: 14,
                  background: svc.color + '18', border: `1px solid ${svc.color}30`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24,
                }}>{svc.icon}</div>
                <span style={{ color: C.text, fontWeight: 700, fontSize: 14 }}>{svc.label}</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* ═══ PROMOÇÕES (if any) ═══════════════════════════ */}
      {promotions.length > 0 && (
        <section style={{ padding: '64px 5%' }}>
          <div style={{ maxWidth: 1000, margin: '0 auto' }}>
            <SectionTitle tag="Promoções" title="Ofertas especiais para você" />
            <div className="l-promo-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(300px,1fr))', gap: 20 }}>
              {promotions.map((p) => <PromoCard key={p.id} promo={p} onEnter={goRegister} />)}
            </div>
          </div>
        </section>
      )}

      {/* ═══ DEPOIMENTOS ══════════════════════════════════ */}
      <section id="depoimentos" style={{ padding: '72px 5%' }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          <SectionTitle
            tag="Depoimentos"
            title="O que dizem nossos clientes"
            sub="Histórias reais de quem já usou o +Qserve"
          />
          <div className="l-test-grid" style={{
            display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 20,
          }}>
            {TESTIMONIALS.map((t) => (
              <div key={t.name} className="l-card" style={{
                background: C.surface, border: `1px solid ${C.border}`,
                borderRadius: 16, padding: 24,
              }}>
                <div style={{ display: 'flex', gap: 3, marginBottom: 14 }}>
                  {'★'.repeat(t.rating).split('').map((_, i) => (
                    <span key={i} style={{ color: C.gold, fontSize: 15 }}>★</span>
                  ))}
                </div>
                <p style={{ color: C.sub, fontSize: 14, lineHeight: 1.75, marginBottom: 20, fontStyle: 'italic' }}>
                  "{t.text}"
                </p>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <div style={{
                    width: 40, height: 40, borderRadius: '50%',
                    background: `linear-gradient(135deg, ${C.accent}, #00a880)`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 14, fontWeight: 900, color: '#000', flexShrink: 0,
                  }}>{t.initials}</div>
                  <div>
                    <div style={{ fontWeight: 800, fontSize: 14, color: C.text }}>{t.name}</div>
                    <div style={{ fontSize: 12, color: C.sub }}>{t.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══ BAIXAR APP ═══════════════════════════════════ */}
      <section id="download" style={{ padding: '72px 5%', background: '#1a1a2e' }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          <SectionTitle tag="Aplicativo Android" title="Baixe o App +Qserve" />
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            marginTop: 40,
          }}>
            <a
              href={MOBILE_APP_URL}
              download
              className="l-cta"
              style={{
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                background: C.accent, color: '#000', border: 'none',
                borderRadius: 13, padding: '16px 34px',
                fontWeight: 900, fontSize: 16, textDecoration: 'none',
                boxShadow: `0 8px 28px ${C.accent}40`,
              }}
            >
              Baixe aqui o aplicativo
            </a>
          </div>
        </div>
      </section>

      {/* ═══ CTA CENTRAL ══════════════════════════════════ */}
      <section style={{
        padding: '72px 5%', textAlign: 'center',
        background: `linear-gradient(135deg, ${C.accent}0a, #3b82f607)`,
        borderTop: `1px solid ${C.border}`, borderBottom: `1px solid ${C.border}`,
      }}>
        <div style={{ maxWidth: 600, margin: '0 auto' }}>
          <h2 style={{ fontSize: 36, fontWeight: 900, color: C.text, letterSpacing: -0.5, marginBottom: 14 }}>
            Pronto para começar?
          </h2>
          <p style={{ color: C.sub, fontSize: 16, lineHeight: 1.75, marginBottom: 34 }}>
            Solicite seu primeiro serviço ou cadastre-se como colaborador verificado agora mesmo.
          </p>
          <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
            <button className="l-cta" onClick={goRegister} style={{
              background: C.accent, color: '#000', border: 'none',
              borderRadius: 13, padding: '16px 42px',
              fontWeight: 900, fontSize: 16, cursor: 'pointer', fontFamily: C.font,
              boxShadow: `0 8px 28px ${C.accent}40`,
            }}>Entrar na plataforma →</button>
            <button className="l-ghost" onClick={goRegister} style={{
              background: 'transparent', color: C.text, border: `1px solid ${C.border}`,
              borderRadius: 13, padding: '16px 32px',
              fontWeight: 700, fontSize: 16, cursor: 'pointer', fontFamily: C.font,
              transition: 'all 0.2s',
            }}>Cadastrar-se grátis</button>
          </div>
        </div>
      </section>

      {/* ═══ ENTRE EM CONTATO ═════════════════════════════ */}
      <section id="contato" style={{ padding: '72px 5%' }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          <SectionTitle
            tag="Entre em Contato"
            title="Fale com a gente"
            sub="Tire suas dúvidas, sugira melhorias ou entre em contato pelo canal de sua preferência"
          />

          <div className="l-contact-row" style={{ display: 'flex', gap: 32, alignItems: 'flex-start', flexWrap: 'wrap' }}>
            {/* Contact info */}
            <div style={{ flex: '1 1 260px' }}>
              {/* WhatsApp */}
              <a
                href={WHATSAPP_URL}
                target="_blank" rel="noopener noreferrer"
                style={{
                  display: 'flex', alignItems: 'center', gap: 14,
                  background: '#25D366', color: '#fff',
                  borderRadius: 12, padding: '14px 20px',
                  textDecoration: 'none', fontWeight: 800, fontSize: 15,
                  marginBottom: 14,
                  boxShadow: '0 4px 20px #25D36640',
                  transition: 'opacity 0.15s',
                }}
                onMouseEnter={(e) => e.currentTarget.style.opacity = '0.88'}
                onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
              >
                <span style={{ fontSize: 22 }}>💬</span>
                WhatsApp - {WHATSAPP_DISPLAY}
              </a>

              {/* Email */}
              <a href={`mailto:${CONTACT_EMAIL}`} style={{
                display: 'flex', alignItems: 'center', gap: 14,
                background: C.surface, border: `1px solid ${C.border}`,
                borderRadius: 12, padding: '14px 20px', marginBottom: 24,
                textDecoration: 'none',
              }}>
                <span style={{ fontSize: 20 }}>✉️</span>
                <div>
                  <div style={{ fontSize: 11, color: C.sub, fontWeight: 600, letterSpacing: 1 }}>EMAIL</div>
                  <div style={{ color: C.text, fontWeight: 700, fontSize: 14 }}>{CONTACT_EMAIL}</div>
                </div>
              </a>

              {/* Redes sociais */}
              <div style={{ marginBottom: 8, fontSize: 12, color: C.sub, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase' }}>Redes Sociais</div>
              <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                {[
                  { icon: '📸', label: 'Instagram', href: 'https://www.instagram.com/qserve2000.rj' },
                  { icon: '📘', label: 'Facebook',  href: '#' },
                ].map((s) => (
                  <a
                    key={s.label}
                    href={s.href}
                    target={s.href === '#' ? undefined : '_blank'}
                    rel={s.href === '#' ? undefined : 'noopener noreferrer'}
                    style={{
                    display: 'flex', alignItems: 'center', gap: 8,
                    background: C.surface, border: `1px solid ${C.border}`,
                    borderRadius: 10, padding: '10px 16px',
                    color: C.text, textDecoration: 'none', fontWeight: 600, fontSize: 14,
                    transition: 'border-color 0.15s',
                  }}
                    onMouseEnter={(e) => e.currentTarget.style.borderColor = C.accent}
                    onMouseLeave={(e) => e.currentTarget.style.borderColor = C.border}
                  >
                    <span style={{ fontSize: 18 }}>{s.icon}</span> {s.label}
                  </a>
                ))}
              </div>
            </div>

            {/* Contact form */}
            <div style={{ flex: '1 1 320px' }}>
              <div style={{
                background: C.surface, border: `1px solid ${C.border}`,
                borderRadius: 16, padding: 28,
              }}>
                {contactSent ? (
                  <div style={{ textAlign: 'center', padding: '24px 0' }}>
                    <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
                    <div style={{ fontWeight: 800, fontSize: 18, color: C.text, marginBottom: 8 }}>Mensagem enviada!</div>
                    <div style={{ color: C.sub, fontSize: 14 }}>Retornaremos em breve pelo e-mail informado.</div>
                    <button onClick={() => { setContactSent(false); setContactForm({ name: '', email: '', message: '' }); }} style={{
                      marginTop: 20, background: 'none', border: `1px solid ${C.border}`,
                      color: C.sub, borderRadius: 8, padding: '8px 20px', cursor: 'pointer', fontFamily: C.font, fontSize: 13,
                    }}>Enviar outra mensagem</button>
                  </div>
                ) : (
                  <form onSubmit={sendContact} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                    <h3 style={{ fontSize: 17, fontWeight: 800, color: C.text, marginBottom: 4 }}>Envie uma mensagem</h3>
                    {[
                      { key: 'name',    label: 'Nome',    type: 'text',  placeholder: 'Seu nome completo' },
                      { key: 'email',   label: 'E-mail',  type: 'email', placeholder: 'seu@email.com' },
                    ].map(({ key, label, type, placeholder }) => (
                      <div key={key}>
                        <label style={{ display: 'block', fontSize: 12, color: C.sub, fontWeight: 600, marginBottom: 5 }}>{label}</label>
                        <input
                          type={type} required placeholder={placeholder}
                          value={contactForm[key]} onChange={setContact(key)}
                          style={{
                            width: '100%', background: C.card, border: `1px solid ${C.border}`,
                            borderRadius: 8, padding: '10px 13px', color: C.text, fontSize: 14,
                            fontFamily: C.font, outline: 'none',
                          }}
                          onFocus={(e) => e.target.style.borderColor = C.accent}
                          onBlur={(e) => e.target.style.borderColor = C.border}
                        />
                      </div>
                    ))}
                    <div>
                      <label style={{ display: 'block', fontSize: 12, color: C.sub, fontWeight: 600, marginBottom: 5 }}>Mensagem</label>
                      <textarea
                        required placeholder="Escreva sua mensagem…" rows={4}
                        value={contactForm.message} onChange={setContact('message')}
                        style={{
                          width: '100%', background: C.card, border: `1px solid ${C.border}`,
                          borderRadius: 8, padding: '10px 13px', color: C.text, fontSize: 14,
                          fontFamily: C.font, resize: 'vertical', outline: 'none',
                        }}
                        onFocus={(e) => e.target.style.borderColor = C.accent}
                        onBlur={(e) => e.target.style.borderColor = C.border}
                      />
                    </div>
                    {contactError && (
                      <div style={{
                        background: 'rgba(248,113,113,0.10)',
                        border: '1px solid rgba(248,113,113,0.35)',
                        borderRadius: 8,
                        color: '#fecaca',
                        fontSize: 13,
                        lineHeight: 1.45,
                        padding: '10px 12px',
                      }}>
                        {contactError}
                      </div>
                    )}
                    <button type="submit" className="l-cta" disabled={contactLoading} style={{
                      background: C.accent, color: '#000', border: 'none',
                      borderRadius: 10, padding: '13px 0', fontWeight: 800,
                      fontSize: 15, cursor: contactLoading ? 'not-allowed' : 'pointer', fontFamily: C.font,
                      opacity: contactLoading ? 0.7 : 1,
                    }}>{contactLoading ? 'Enviando...' : 'Enviar mensagem'}</button>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══ FOOTER ═══════════════════════════════════════ */}
      <footer style={{ background: C.surface, borderTop: `1px solid ${C.border}`, padding: '52px 5% 28px' }}>
        <div className="l-footer-top" style={{ display: 'flex', gap: 36, flexWrap: 'wrap', maxWidth: 1100, margin: '0 auto', marginBottom: 36, justifyContent: 'space-between' }}>

          {/* Brand */}
          <div style={{ minWidth: 200 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
              <div style={{
                width: 34, height: 34, borderRadius: 8,
                background: `linear-gradient(135deg, ${C.accent}, #00a880)`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 16, fontWeight: 900, color: '#000',
              }}>Q</div>
              <span style={{ fontWeight: 900, fontSize: 18, color: C.text }}>+Qserve</span>
            </div>
            <p style={{ color: C.sub, fontSize: 13, lineHeight: 1.7, maxWidth: 220 }}>
              Plataforma de mão de obra verificada e certificada em todo o Brasil.
            </p>
          </div>

          {/* Links */}
          <div>
            <div style={{ fontWeight: 700, fontSize: 12, color: C.text, marginBottom: 14, letterSpacing: 1, textTransform: 'uppercase' }}>Links</div>
            {[
              { label: 'Quem Somos',     href: '#quem-somos' },
              { label: 'Serviços',       href: '#servicos' },
              { label: 'Como Funciona',  href: '#como-funciona' },
              { label: 'Contato',        href: '#contato' },
            ].map((l) => (
              <div key={l.label} style={{ marginBottom: 8 }}>
                <a href={l.href} style={{ color: C.sub, fontSize: 14, textDecoration: 'none', transition: 'color 0.15s' }}
                  onMouseEnter={(e) => e.target.style.color = C.accent}
                  onMouseLeave={(e) => e.target.style.color = C.sub}
                >{l.label}</a>
              </div>
            ))}
          </div>

          {/* Plataforma */}
          <div>
            <div style={{ fontWeight: 700, fontSize: 12, color: C.text, marginBottom: 14, letterSpacing: 1, textTransform: 'uppercase' }}>Plataforma</div>
            {['Entrar', 'Cadastrar', 'Seja Colaborador'].map((l) => (
              <div key={l} style={{ marginBottom: 8 }}>
                <button onClick={goLogin} style={{
                  background: 'none', border: 'none', color: C.sub, fontSize: 14,
                  cursor: 'pointer', fontFamily: C.font, padding: 0, transition: 'color 0.15s',
                }}
                  onMouseEnter={(e) => e.target.style.color = C.accent}
                  onMouseLeave={(e) => e.target.style.color = C.sub}
                >{l}</button>
              </div>
            ))}
          </div>

          {/* App download */}
          <div>
            <div style={{ fontWeight: 700, fontSize: 12, color: C.text, marginBottom: 14, letterSpacing: 1, textTransform: 'uppercase' }}>Abra nosso App</div>
            <a
              href={MOBILE_APP_URL}
              target="_blank" rel="noopener noreferrer"
              style={{
                display: 'flex', alignItems: 'center', gap: 12,
                background: C.card, border: `1px solid ${C.border}`,
                borderRadius: 12, padding: '12px 18px',
                textDecoration: 'none', transition: 'border-color 0.15s',
              }}
              onMouseEnter={(e) => e.currentTarget.style.borderColor = '#3DDC84'}
              onMouseLeave={(e) => e.currentTarget.style.borderColor = C.border}
            >
              <span style={{ fontSize: 15, fontWeight: 900, color: C.text }}>APK</span>
              <div>
                <div style={{ fontSize: 10, color: C.sub }}>Download</div>
                <div style={{ fontSize: 15, fontWeight: 800, color: C.text }}>Aplicativo Android</div>
              </div>
            </a>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="l-footer-bottom" style={{
          borderTop: `1px solid ${C.border}`, paddingTop: 20,
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          flexWrap: 'wrap', gap: 10, maxWidth: 1100, margin: '0 auto',
        }}>
          <span style={{ color: C.muted, fontSize: 13 }}>
            © 2026 +Qserve — maisqserve.com.br · Todos os direitos reservados
          </span>
          <div style={{ display: 'flex', gap: 20 }}>
            {[
              { label: 'Privacidade', href: '/privacidade' },
              { label: 'Termos de Uso', href: '/termos-de-uso' },
            ].map((link) => (
              <a key={link.href} href={link.href} style={{
                color: C.muted, fontSize: 13, fontFamily: C.font, textDecoration: 'none',
              }}>{link.label}</a>
            ))}
          </div>
        </div>
      </footer>
    </div>
  );
}

// ── PromoCard ──────────────────────────────────────────────
function PromoCard({ promo, onEnter }) {
  const hasBadge = promo.badge?.trim();
  const imageUrl = safePublicUrl(promo.imageUrl);
  const targetUrl = safePublicUrl(promo.link);
  const hasImage = !!imageUrl;
  const isClickable = !!targetUrl;

  const handleClick = () => {
    if (isClickable) window.open(targetUrl, '_blank', 'noopener,noreferrer');
    else onEnter();
  };

  return (
    <div className="l-card" onClick={handleClick} style={{
      background: C.surface, border: `1px solid ${C.border}`,
      borderRadius: 16, overflow: 'hidden', cursor: 'pointer',
      boxShadow: '0 4px 20px #00000028',
    }}>
      {hasImage && (
        <div style={{ height: 180, overflow: 'hidden' }}>
          <img src={imageUrl} alt={promo.title}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            onError={(e) => { e.target.style.display = 'none'; }} />
        </div>
      )}
      <div style={{ padding: 20 }}>
        {!hasImage && hasBadge && (
          <span style={{
            background: C.goldDim, color: C.gold, border: `1px solid ${C.gold}40`,
            borderRadius: 8, padding: '3px 10px', fontSize: 12, fontWeight: 800,
            display: 'inline-block', marginBottom: 10,
          }}>{promo.badge}</span>
        )}
        <div style={{ fontWeight: 800, fontSize: 16, color: C.text, marginBottom: 8 }}>{promo.title}</div>
        {promo.description && <div style={{ color: C.sub, fontSize: 14, lineHeight: 1.6 }}>{promo.description}</div>}
        <div style={{ marginTop: 14, color: C.accent, fontSize: 13, fontWeight: 700 }}>
          {isClickable ? 'Saiba mais →' : 'Aproveitar →'}
        </div>
      </div>
    </div>
  );
}
